import React from 'react';
import resources from '../../resources';

const ImageBulletedSection = ({ items }) => {
  const containerStyle = { marginBottom: 48 };

  const bulletTitleStyle = {
    fontSize: 16,
    fontWeight: 600,
    color: '#212121',
    marginTop: 32,
    marginBottom: 16,
  };

  const descriptionStyle = {
    fontSize: 16,
    lineHeight: '24px',
    color: '#212121',
    marginTop: 16,
    marginBottom: 20,
  };

  const imageStyle = {
    width: '100%',
    borderRadius: 8,
    objectFit: 'cover',
  };

  return (
    <div style={containerStyle}>
      {items.map((item, index) => {
        const imageCount = item.image?.length || 1;

        return (
          <div key={index}>
           {item.title == "" ? <></> : <div style={bulletTitleStyle}>{item.title}</div>} 
            {/* Custom layout for 3 images */}
            {imageCount === 3 ? (
              <div style={{ marginBottom: 16 }}>
                {/* Image 1 - Full width */}
                <div style={{ marginBottom: 16 }}>
                  <img
                    src={resources.images[item.image[0]]}
                    alt={`${item.title} - 1`}
                    style={imageStyle}
                  />
                </div>
                {/* Image 2 + 3 - Side by side */}
                <div style={{ display: 'flex', gap: 16 }}>
                  <img
                    src={resources.images[item.image[1]]}
                    alt={`${item.title} - 2`}
                    style={{ ...imageStyle, width: 'calc(50% - 8px)' }}
                    />
                  <img
                    src={resources.images[item.image[2]]}
                    alt={`${item.title} - 3`}
                    style={{ ...imageStyle, width: 'calc(50% - 8px)' }}
                    />
                </div>
              </div>
            ) : (
              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns: `repeat(${imageCount}, 1fr)`,
                  gap: 16,
                  marginBottom: 16,
                }}
              >
                {item.image?.map((imgKey, i) => (
                  <img
                    key={i}
                    src={resources.images[imgKey]}
                    alt={`${item.title} - ${i + 1}`}
                    style={imageStyle}
                  />
                ))}
              </div>
            )}

            {item.text?.map((paragraph, pi) => (
              <p key={pi} style={descriptionStyle}>
                {paragraph}
              </p>
            ))}
          </div>
        );
      })}
    </div>
  );
};

export default ImageBulletedSection;
